export default {"src":"/_next/static/media/star.cf06a4ea.svg","height":26,"width":28};